/**
 * A collection of tools for working with XML.
 *
 * @groupDescription XML
 * @packageDocumentation
 * @beta
 */
export { getElementsByName } from './xml/getElementsByName.js';
export { parseXml } from './xml/parseXml.js';
export type { XmlNode } from './xml/XmlNode.js';
export type { XmlParseOptions } from './xml/XmlParseOptions.js';
